export interface LauncherProps {
  open: boolean;
  botName: string;
  unreadCount: number;
  teaser?: string;
  /** An agent is on the line — worth showing on the closed launcher, because it changes what the shopper expects. */
  agentOnline: boolean;
  agentTyping: boolean;
  onToggle: () => void;
}

/**
 * The launcher is a state machine: `idle | unread(n) | typing |
 * agent-online` (PLAN.md "Attention & unread"). The teaser bubble is the
 * part that earns its keep — it's what makes an agent's reply land when the
 * shopper has closed the widget and wandered off, which is otherwise the
 * most common way a takeover goes unnoticed.
 *
 * The attention animation is gated on `prefers-reduced-motion` in the
 * stylesheet rather than here, so the markup stays declarative.
 */
export function Launcher(props: LauncherProps) {
  const state = props.open ? "open" : props.agentTyping ? "typing" : props.unreadCount > 0 ? "unread" : props.agentOnline ? "agent-online" : "idle";

  return (
    <div class="cos-launcher-wrap">
      {!props.open && props.unreadCount > 0 && (
        <button type="button" class="cos-teaser" role="status" onClick={props.onToggle}>
          <span class="cos-teaser-label">{props.unreadCount > 1 ? `${props.unreadCount} new messages` : "New message"}</span>
          {props.teaser && <span class="cos-teaser-text">{props.teaser}</span>}
        </button>
      )}
      <button
        type="button"
        class="cos-launcher"
        data-state={state}
        aria-label={props.open ? "Close chat" : props.unreadCount > 0 ? `Chat with ${props.botName || "us"} — ${props.unreadCount} unread` : `Chat with ${props.botName || "us"}`}
        aria-expanded={props.open}
        onClick={props.onToggle}
      >
        {props.open ? "\u00d7" : "\ud83d\udcac"}
        {!props.open && props.unreadCount > 0 && (
          <span class="cos-unread-badge" aria-hidden="true">
            {props.unreadCount > 9 ? "9+" : props.unreadCount}
          </span>
        )}
      </button>
    </div>
  );
}
